import React from 'react';
import {Link} from 'react-router-dom';
import {Col, Container, Row} from 'reactstrap';

import logolight from "../assets/images/Project/hrplus-white.png";
import {useTranslation} from 'react-i18next';
import {appConfig} from "../config";
import {YandexMap} from "../Components";

const Footer = () => {
    const {t} = useTranslation();

    return (
        <div className={"layout-wrapper landing"}>
            <footer className="custom-footer bg-dark py-5 position-relative"
                    style={{backgroundColor: "var(--vz-secondary-bg)"}}>
                <Container>
                    <Row>
                        <Col lg={3} xl={2} md={12} sm={12}>
                            <div>
                                <div className="mt-n2 ms-n1">
                                    <img src={logolight} alt="logo light" height="50"/>
                                </div>
                                <div className="d-flex mt-3 gap-1">
                                    <Link to="#" className="text-white"><i className="ri-youtube-fill"
                                                                           style={{fontSize: "1.6rem"}}></i></Link>
                                    <Link to="#" className="text-white"><i className="ri-instagram-fill"
                                                                           style={{fontSize: "1.6rem"}}></i></Link>
                                    <Link to="https://t.me/Jack_20010912" className="text-white"><i
                                        className="ri-telegram-fill" style={{fontSize: "1.6rem"}}></i></Link>
                                </div>
                            </div>
                        </Col>

                        <Col lg={8} xl={9} className="ms-lg-auto" md={12} sm={12}>
                            <Row className="fs-15">
                                <Col lg={3} md={6} sm={6} xs={12}>
                                    <h5 className="text-white mb-0">{t('t-company')}</h5>
                                    <div className="text-muted mt-3">
                                        <ul className="list-unstyled ff-secondary footer-list">
                                            <li><Link to="/about-us">{t('t-about-us')}</Link></li>
                                        </ul>
                                    </div>
                                </Col>
                                <Col lg={3} md={6} sm={6} xs={12}>
                                    <h5 className="text-white mb-0">{t('t-products')}</h5>
                                    <div className="text-muted mt-3">
                                        <ul className="list-unstyled ff-secondary footer-list">
                                            <li><Link to="#"
                                                      onClick={e => e.preventDefault()}>{t('t-live-location')}</Link>
                                            </li>
                                            <li><Link to="#"
                                                      onClick={e => e.preventDefault()}>{t('t-tasks-footer')}</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </Col>
                                <Col lg={3} md={6} sm={12} xs={12}>
                                    <h5 className="text-white mb-0">{t('t-contact2')}</h5>
                                    <div className="text-muted mt-3">
                                        <ul className="list-unstyled ff-secondary footer-list">
                                            <li>
                                                <Link to="tel:+998940020912" className="d-flex align-items-center">
                                                    <i className="ri-phone-fill fs-18 me-2"></i>
                                                    +998 94 002-09-12
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="https://t.me/Jack_20010912"
                                                      className="d-flex align-items-center">
                                                    <i className="ri-telegram-fill fs-18 me-2"></i>
                                                    {t('t-telegram')}
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/support" className="d-flex align-items-center">
                                                    <i className="ri-customer-service-2-fill fs-18 me-2"></i>
                                                    {t('t-support') || 'Support'}
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </Col>
                                <Col lg={3} md={6} sm={12} xs={12}>
                                    <YandexMap coords={appConfig.organization.location_coords} zoom={15} height={170}/>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <Row className="text-center text-sm-start align-items-center mt-5">
                        <Col sm={6}>
                            <div>
                                <p className="copy-rights mb-0 fs-14 text-white">
                                    2023
                                    © {t('t-all-rights-reserved').replace("{appName}", appConfig.appName) || `All rights reserved ${appConfig.appName}`}
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </div>
    );
};

export default Footer;